module.exports = __webpack_public_path__ + "static/media/how-it-works-landlord-10.ab947a5f.svg";